import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';

import SiteNavLink from '../buttons/SiteNavLink/SiteNavLink';
import Button from '../buttons/Button/Button';
import CallUsButton from '../buttons/CallUsButton/CallUsButton';

import logo from './images/logo_home.webp';
// NavBar CSS
import './Navbar.css';

export default function Navbar() {
  const location = useLocation();

  const navItems = [
    { label: 'Home', to: '/' },
    {
      label: 'About Us',
      paths: ['/our-process', 'our-team', '/faq'],
      children: [
        { label: 'Our Process', to: '/our-process' },
        { label: 'Our Team', to: '/our-team' },
        { label: 'FAQ', to: '/faq' },
      ],
    },
    {
      label: 'Services',
      paths: ['/our-services', '/conditions'],
      children: [
        { label: 'Our Services', to: '/our-services' },
        { label: 'Conditions Treated', to: '/conditions' },
      ],
    },
    { label: 'Billing', to: '/rates' },
    { label: 'Products', to: '/products' },
    { label: 'Blog', to: '/blog' },
    { label: 'Contact Us', to: '/contact-us' },
  ];

  const isActive = (paths = []) =>
    paths.some((path) => location.pathname.startsWith(path));

  const handleOnClick = () => {
    const y = document.getElementById('MyMenuIcon');
    y.classList.toggle('change');

    const x = document.getElementById('MyTopNav');
    if (x.className === 'nav-subheader-items-container') {
      x.className += ' responsive';
    } else {
      x.className = 'nav-subheader-items-container';
    }
  };

  return (
    <>
      <div className='nav-header'>
        <div className='nav-header-left-container'>
          {/* Pro Evolution Wellness logo */}
          <div className='nav-logo-container'>
            <NavLink to='/' className='nav-link-logo'>
              <img src={logo} alt='pro-evo-logo' className='nav-logo' />
            </NavLink>
          </div>
        </div>
        <div className='nav-header-center-container'>
          {/* Free consultation button */}
          <div className='nav-free-consult-container'>
            <SiteNavLink destination='/free-consultation' isHLeftAligned={true}>
              <span className='free-consultation-nav-text'>
                Free 10 min <span className='break-on-small'>consult</span>
              </span>
            </SiteNavLink>
          </div>
          <div className='nav-btn-container'>
            {/* Book appointemnt button */}
            <Button
              fixedWidth={false}
              href='https://proevolutionwellness.janeapp.com/'
            >
              <span className='book-appointment-nav-text'>
                Book{' '}
                <span className='break-on-small'>
                  <span className='disappear-on-small'>Appointment</span>
                </span>
              </span>
            </Button>
            {/* Call us button */}
            <CallUsButton fixedWidth={false} phoneNumber='19053030337'>
              <span className='call-us-nav-text'>
                Call <span className='break-on-small'></span>
                <span className='disappear-on-small'>Us</span>
              </span>
            </CallUsButton>
          </div>
        </div>
        {/* Hamburger menu icon*/}
        <div className='nav-links-container'>
          <div className='menu-icon-container'>
            <NavLink onClick={handleOnClick}>
              <div className='menu-icon' id='MyMenuIcon'>
                <div className='menu-icon-bar1'></div>
                <div className='menu-icon-bar2'></div>
                <div className='menu-icon-bar3'></div>
              </div>
            </NavLink>
          </div>
        </div>
      </div>

      {/* Horizontal Navigation bar */}
      <nav className='nav-subheader'>
        <div className='nav-subheader-items-container' id='MyTopNav'>
          {navItems.map(({ label, to, paths, children }) => (
            <li
              key={label}
              className={[
                'nav-subheader-item-container',
                isActive(paths) ? 'active' : '',
              ]
                .filter(Boolean)
                .join(' ')}
            >
              {children ? (
                <div className='dropdown'>
                  <div className='item-title'>
                    <span className='item-title-name'>{label}</span>
                  </div>
                  <ul className='dropdown-menu'>
                    {children.map((child) => (
                      <li key={child.to} className='dropdown-item'>
                        <div className='dropdown-item-title'>
                          <SiteNavLink destination={child.to} isHLeftAligned>
                            <span className='dropdown-item-title-text'>
                              {child.label}
                            </span>
                          </SiteNavLink>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              ) : (
                <div className='item-title'>
                  <SiteNavLink destination={to}>{label}</SiteNavLink>
                </div>
              )}
            </li>
          ))}
        </div>
      </nav>
    </>
  );
}
